'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _ValidatedQuickForm = require('./ValidatedQuickForm');

var _ValidatedQuickForm2 = _interopRequireDefault(_ValidatedQuickForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Auto = function Auto(parent) {
    var _class, _temp;

    return _temp = _class = function (_parent) {
        (0, _inherits3.default)(_class, _parent);

        function _class() {
            (0, _classCallCheck3.default)(this, _class);

            var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));

            _this.state = (0, _extends3.default)({}, _this.state, {

                model: _this.props.model,
                modelSync: _this.props.model
            });
            return _this;
        }

        (0, _createClass3.default)(_class, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(_ref) {
                var model = _ref.model;

                (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'componentWillReceiveProps', this).apply(this, arguments);

                if (!(0, _isEqual2.default)(this.props.model, model)) {
                    this.setState(function () {
                        return { model: model, modelSync: model };
                    });
                }
            }
        }, {
            key: 'getNativeFormProps',
            value: function getNativeFormProps() {
                var _get$call = (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'getNativeFormProps', this).call(this),
                    onChangeModel = _get$call.onChangeModel,
                    props = (0, _objectWithoutProperties3.default)(_get$call, ['onChangeModel']);

                return props;
            }
        }, {
            key: 'getModel',
            value: function getModel(mode) {
                return mode === 'form' ? this.state.modelSync : this.state.model;
            }
        }, {
            key: 'onChange',
            value: function onChange(key, value) {
                var _this2 = this,
                    _arguments = arguments;

                var updateState = function updateState(state) {
                    return { modelSync: (0, _set2.default)((0, _cloneDeep2.default)(state.modelSync), key, value) };
                };
                var updateModel = function updateModel(state) {
                    if (_this2.props.onChangeModel) {
                        _this2.props.onChangeModel(state.modelSync);
                    }

                    return { model: state.modelSync };
                };

                // Before componentDidMount, every call to onChange should call BaseForm#onChange synchronously
                if (this.state.changed === null) {
                    this.setState(updateState);
                    (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onChange', this).apply(this, arguments);
                    this.setState(updateModel);
                } else {
                    this.setState(updateState, function () {
                        (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onChange', _this2).apply(_this2, _arguments);
                        _this2.setState(updateModel);
                    });
                }
            }
        }, {
            key: 'onReset',
            value: function onReset() {
                var _this3 = this;

                this.setState(function () {
                    (0, _get3.default)(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onReset', _this3).call(_this3);

                    return {
                        model: _this3.props.model,
                        modelSync: _this3.props.model
                    };
                });
            }
        }, {
            key: 'onValidate',
            value: function onValidate() {
                return this.onValidateModel(this.getChildContextModel());
            }
        }]);
        return _class;
    }(parent), _class.Auto = Auto, _class.displayName = 'Auto' + parent.displayName, _class.propTypes = (0, _extends3.default)({}, parent.propTypes, {

        onChangeModel: _propTypes2.default.func
    }), _temp;
};

exports.default = Auto(_ValidatedQuickForm2.default);


//////////////////
// WEBPACK FOOTER
// ./~/uniforms/AutoForm.js
// module id = 637
// module chunks = 35783957827783 65974612472484